import s from "./styles.module.sass";

type CourseRequirementsProps = {
	requirements: Array<string>;
};

const CourseReqs = ({ requirements }: CourseRequirementsProps) => {
	return (
		<section className={s.courseReqs}>
			<h2>Требования</h2>
			<ul className={s.reqsList}>
				{requirements.map((req, index: number) => {
					return <li key={index}>{req}</li>;
				})}
			</ul>
		</section>
	);
};

export default CourseReqs;
